import { ResponsiveBar } from '@nivo/bar';
import { polarColors, colorsFive, greenScaleColors } from '../constants';

const BASE_KEYS = ['Muy Bajo', 'Bajo', 'Medio', 'Alto', 'Muy Alto'];
// const groups = ['Muy Bajo', 'Bajo', 'Medio', 'Alto'];

const getValueGroup = (val, keys) => {
  const value = parseFloat(val);
  if (value < 25) {
    return keys[0];
  }
  if (value < 40) {
    return keys[1];
  }
  if (value < 60) {
    return keys[2];
  }
  if (value < 75) {
    return keys[3];
  }
  return keys[4];
};

const groupColor = (group, scale, keys) => {
  let colorScale = colorsFive;
  if (scale === 'greenScale') {
    colorScale = greenScaleColors;
  }
  if (scale === 'polar') {
    colorScale = polarColors;
  }
  switch (group) {
    case keys[0]:
      return colorScale[0];
    case keys[1]:
      return colorScale[1];
    case keys[2]:
      return colorScale[2];
    case keys[3]:
      return colorScale[3];
    case keys[4]:
      return colorScale[4];
    default:
      return colorScale[0];
  }
};

// const getValueGroup = val => {
//   const value = parseFloat(val);
//   if (value < 25) {
//     return 'Muy Bajo';
//   }
//   if (value < 50) {
//     return 'Bajo';
//   }
//   if (value < 75) {
//     return 'Medio';
//   }
//   return 'Alto';
// };

// const groupColor = (group, scale) => {
//   let colorScale = colorsFive;
//   if (scale === 'greenScale') {
//     colorScale = greenScaleColors;
//   }
//   if (scale === 'polar') {
//     colorScale = polarColors;
//   }
//   switch (group) {
//     case 'Muy Bajo':
//       return colorScale[0];
//     case 'Bajo':
//       return colorScale[1];
//     case 'Medio':
//       return colorScale[3];
//     case 'Alto':
//       return colorScale[4];
//     // case 'Muy Alto':
//     //   return colorScale[0];
//     default:
//       return colorScale[0];
//   }
// };

const getDimData = ({ responses, scales, maxScale, colorPallete, keys }) => {
  const data = scales.map(s => {
    const responseValue = Number(responses[s.scale]);
    return {
      dimension: s.scale,
      value: parseFloat(
        maxScale ? (responseValue / maxScale) * 100 : responseValue
      )
    };
  });

  const dataWithDetails = data.map(el => {
    const group = getValueGroup(el.value, keys);
    const color = groupColor(group, colorPallete, keys);
    return { ...el, group, color };
  });
  // console.log({ dataWithDetails });

  const groupedData = dataWithDetails.map(dp => {
    const groupsvals = keys.reduce((acc, curr) => {
      let val = 0;
      if (curr === dp.group) {
        val = dp.value;
      }
      return { ...acc, [curr]: val };
    }, {});

    const barData = {
      ...dp,
      dimension: dp.dimension,
      ...groupsvals
    };
    delete barData.group;
    delete barData.color;
    delete barData.value;
    return barData;
  });
  return groupedData;
};

const getGroupData = ({
  responses = [],
  scales = [],
  maxScale,
  colorPallete,
  KEYS = BASE_KEYS
}) => {
  const total = responses.length;
  const allCases = responses
    .map(resp =>
      getDimData({
        responses: resp.data,
        scales,
        maxScale,
        colorPallete,
        keys: KEYS
      })
    )
    .flat();
  const groups = scales.map(s => s.scale);
  const groupedCount = groups.map(group => {
    const groupCases = allCases.filter(
      resPoint => resPoint.dimension === group
    );
    // console.log({ groupCases, group });
    const filters = {
      // Bajo: groupCases.filter(dp => dp['Bajo']).length,
      // Medio: groupCases.filter(dp => dp['Medio']).length,
      // Alto: groupCases.filter(dp => dp['Alto']).length,
      // 'Muy Alto': groupCases.filter(dp => dp['Muy Alto']).length
      [KEYS[1]]: groupCases.filter(dp => dp[KEYS[1]]).length,
      [KEYS[2]]: groupCases.filter(dp => dp[KEYS[2]]).length,
      [KEYS[3]]: groupCases.filter(dp => dp[KEYS[3]]).length,
      [KEYS[4]]: groupCases.filter(dp => dp[KEYS[4]]).length
    };
    const filteredSum = Object.keys(filters).reduce(
      (acc, curr) => acc + filters[curr],
      0
    );
    // console.log({ filteredSum });
    const groupBar = {
      dimension: group,
      ...filters,
      // use lowest group as all remainder
      // 'Muy Bajo': groupCases.filter(dp => dp['Muy Bajo']).length,
      // 'Muy Bajo': total - filteredSum,
      [KEYS[0]]: total - filteredSum
    };
    return groupBar;
  });
  // console.log({ allCases, total, groupedCount });
  return groupedCount;
};

const SCALES_DEFAULT = [{ scale: 'ABIND_01', label: 'Habilidades Numéricas' }];
const MyResponsiveBar = ({
  responses,
  scales = SCALES_DEFAULT,
  maxScale,
  showLabels = true,
  leftMargin = 255,
  rightMargin = 145,
  showLegend,
  colorPallete,
  inverse = false,
  keys = BASE_KEYS
}) => {
  const KEYS = keys;
  // const dimData = getDimData(responses[0].data);
  const groupData = getGroupData({
    responses,
    scales,
    maxScale,
    colorPallete,
    KEYS
  });
  // console.log({ dimData });
  // console.log({ responses });
  // console.log({ scales });
  // console.log({ groupData });

  const fields = KEYS.map(g => ({
    key: g,
    color: groupColor(g, colorPallete, KEYS)
  }));
  // console.log({ fields });
  return (
    <ResponsiveBar
      theme={{
        fontSize: 20,
        labels: {
          text: {
            fontSize: 22
          }
        },
        legends: {
          text: {
            fontSize: 18
          }
        }
      }}
      data={groupData}
      keys={[...fields.map(f => f.key)]}
      indexBy='dimension'
      layout='horizontal'
      // groupMode='grouped'
      isInteractive={false}
      margin={{
        top: 0,
        right: showLegend ? rightMargin : 20,
        bottom: 35,
        left: showLabels ? leftMargin : 20
      }}
      padding={scales.length > 1 ? 0.3 : showLegend ? 0.3 : 0}
      // maxValue={100}
      valueScale={{ type: 'linear' }}
      // colors={({ data }) => {
      //   console.log({ data });
      //   return data.color;
      // }}
      colors={
        inverse
          ? [...fields.map(f => f.color)].reverse()
          : [...fields.map(f => f.color)]
      }
      // colorBy={({ data }) => data.group}
      borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
      axisTop={null}
      axisRight={null}
      enableGridX
      enableGridY={false}
      axisLeft={
        showLabels
          ? {
              // tickRotation: 25,
              format: v => {
                const currItem = scales.find(s => s.scale === v);
                return currItem?.label || v;
              }
            }
          : null
      }
      label={d => `${parseFloat(d.value).toFixed(0)}`}
      axisBottom={{
        format: v => (Number.isInteger(v) ? v : '')
      }}
      // axisBottom={{
      //   tickSize: 5,
      //   tickPadding: 5,
      //   tickRotation: 0,
      //   legend: 'country',
      //   legendPosition: 'middle',
      //   legendOffset: 32
      // }}
      // axisLeft={{
      //   tickSize: 5,
      //   tickPadding: 5,
      //   tickRotation: 0,
      //   legend: 'Dimension',
      //   legendPosition: 'middle',
      //   legendOffset: -40
      // }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      // labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
      legends={
        showLegend
          ? [
              {
                // data: 'data.group',
                anchor: 'right',
                direction: 'column',
                justify: false,
                translateX: 128,
                translateY: 16,
                itemsSpacing: 8,
                // itemTextColor: '#fff',
                itemWidth: 100,
                itemHeight: 26,
                itemDirection: 'left-to-right',
                // itemOpacity: 0.85,
                symbolSize: 26
                // symbolShape: 'square',
                // symbolBorderColor: 'rgba(0, 0, 0, 0)'
              }
              // {
              //   dataFrom: 'group',
              //   anchor: 'bottom-right',
              //   direction: 'column',
              //   justify: false,
              //   translateX: 120,
              //   translateY: 0,
              //   itemsSpacing: 2,
              //   itemWidth: 100,
              //   itemHeight: 20,
              //   itemDirection: 'left-to-right',
              //   itemOpacity: 0.85,
              //   symbolSize: 20,
              //   effects: [
              //     {
              //       on: 'hover',
              //       style: {
              //         itemOpacity: 1
              //       }
              //     }
              //   ]
              // }
            ]
          : undefined
      }
      animate={false}
      motionStiffness={90}
      motionDamping={15}
    />
  );
};

export default MyResponsiveBar;
